import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import * as fromModels from '../models'; // Adjust the path as needed
import { Observable, of } from 'rxjs';
import { Constant } from '../constants';
import { Utils } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class AdvisorService {

  constructor(private httpClient:HttpService) { }

  getAdvisors(bmEmail: string, isFA: boolean): Observable<fromModels.AdvisorHirerarchy> {
    //return of(_advisors).delay(2000);
    // if (isFA) {
    //   return (of(new fromModels.AdvisorHirerarchy()));
    // }
    return this.httpClient.get<fromModels.AdvisorHirerarchy>(Constant.uri.advisorHierarchy + "?bmEmail=" + bmEmail, Utils.getHttpOptions());
  }
}
